import "./buttons.scss";

import ICON from "../icons/plusIcon.svg";

export const PlusButton = (props: {
  onClick: () => void;
  hint?: string;
}): JSX.Element => {
  return (
    <button className="plus rg-button rg-red" onClick={props.onClick} title={props.hint}>
      <img src={ICON} alt="" />
    </button>
  );
};
